import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';


//************* BIENESTAR  ***************************/

import { DireccionEstructuraFamiliarService } from '../direccionEstructuraFamiliar/direccionEstructuraFamiliar.service';
import { DireccionPersonaService } from '../direccionPersona/direccionPersona.service';
import { DiscapacidadService } from '../discapacidad/discapacidad.service';
import { DiscapacidadPersonaService } from '../discapacidadPersona/discapacidadPersona.service';
import { Interceptor } from '../../token/interceptor';
import { ContactoEmergenciaService } from '../contactoEmergencia/contactoEmergencia.service';
import { TituloEducacionService } from '../tituloEducacion/tituloEducacion.service';
import { TituloEducacionPersonaService } from '../tituloEducacionPersona/tituloEducacionPersona.service';
import { FichaPersonaService } from '../fichaPersona/fichaPersona.service';
import { HistorialFichaPersonaService } from '../historialFichaPersona/historialFichaPersona.service';
import { TipoInstitucionService } from '../tipoInstitucion/tipoInstitucion.service';
import { ControlInstitucionService } from '../controlInstitucion/controlInstitucion.service';
import { MotivosBecaService } from '../motivosBeca/motivosBeca.service';
import { MotivosBecaSolicitudService } from '../motivosBecaSolicitud/motivosBecaSolicitud.service';
import { EtapaService } from '../etapa/etapa.service';
import { IdiomaPersonaService } from '../idiomaPersona/idiomaPersona.service';
import { IdiomaService } from '../idioma/idioma.service';
import { NivelIdiomaService } from '../nivelIdioma/nivelIdioma.service';
import { ConfiguracionSistemaService } from '../../general/configuracionSistema/configuracionSistema.service';
import { AguaService } from '../agua/agua.service';
import { CalculoGpseService } from '../calculoGpse/calculoGpse.service';
import { DatosCalculoService } from '../datosCalculo/datosCalculo.service';
import { DesechoAguasService } from '../desechoAguas/desechoAguas.service';
import { DormitoriosService } from '../dormitorios/dormitorios.service';
import { EnfermedadService } from '../enfermedad/enfermedad.service';
import { EnfermedadPersonaService } from '../enfermedadPersona/enfermedadPersona.service';
import { HistorialSolicitudAyudaService } from '../historialSolicitudAyuda/historialSolicitudAyuda.service';
import { InodorosService } from '../inodoros/inodoros.service';
import { InstitucionService } from '../institucion/institucion.service';
import { OcupacionService } from '../ocupacion/ocupacion.service';
import { PatrimonioFamiliarService } from '../patrimonioFamiliar/patrimonioFamiliar.service';
import { PatrimonioFamiliarPersonaService } from '../patrimonioFamiliarPersona/patrimonioFamiliarPersona.service';
import { ReferenciaFamiliarService } from '../referenciaFamiliar/referenciaFamiliar.service';
import { RepresentanteAyudaService } from '../representanteAyuda/representanteAyuda.service';
import { TelefonoConvencionalService } from '../telefonoConvencional/telefonoConvencional.service';
import { TipoConfiguracionService } from '../tipoConfiguracion/tipoConfiguracion.service';
import { TipoEconomiaService } from '../tipoEconomia/tipoEconomia.service';
import { TipoGpseService } from '../tipoGpse/tipoGpse.service';
import { UbicacionViviendaService } from '../ubicacionVivienda/ubicacionVivienda.service';
import { UsoVehiculoService } from '../usoVehiculo/usoVehiculo.service';
import { UsoViviendaService } from '../usoVivienda/usoVivienda.service';
import { ValoracionService } from '../valoracion/valoracion.service';
import { EconomiaPersonaService } from '../economiaPersona/economiaPersona.service';
import { EconomiaService } from '../economia/economia.service';
import { EspecialidadService } from '../especialidad/especialidad.service';
import { EstructuraFamiliarService } from '../estructuraFamiliar/estructuraFamiliar.service';
import { EtniaService } from '../etnia/etnia.service';
import { GeneroService } from '../genero/genero.service';
import { GrupoSocioEconomicoService } from '../grupoSocioEconomico/grupoSocioEconomico.service';
import { HistorialSolicitudBecaService } from '../historialSolicitudBeca/historialSolicitudBeca.service';
import { InstitucionFinancieraService } from '../institucionFinanciera/institucionFinanciera.service';
import { InstitucionFinancieraPersonaService } from '../institucionFinancieraPersona/institucionFinancieraPersona.service';
import { InstitucionPersonaService } from '../institucionPersona/institucionPersona.service';
import { InstruccionService } from '../instruccion/instruccion.service';
import { InternetService } from '../internet/internet.service';
import { MaterialesParedService } from '../materialesPared/materialesPared.service';
import { MaterialesPisoService } from '../materialesPiso/materialesPiso.service';
import { MaterialesViviendaService } from '../materialesVivienda/materialesVivienda.service';
import { NacionalidadService } from '../nacionalidad/nacionalidad.service';
import { OrientacionSexualService } from '../orientacionSexual/orientacionSexual.service';
import { OtraInstitucionPersonaService } from '../otraInstitucionPersona/otraInstitucionPersona.service';
import { ParentezcoService } from '../parentezco/parentezco.service';
import { ProfesionService } from '../profesion/profesion.service';
import { PuebloService } from '../pueblo/pueblo.service';
import { SeguroService } from '../seguro/seguro.service';
import { ServiciosBasicosService } from '../serviciosBasicos/serviciosBasicos.service';
import { ServiciosBasicosPersonaService } from '../serviciosBasicosPersona/serviciosBasicosPersona.service';
import { SexoService } from '../sexo/sexo.service';
import { TenenciaViviendaService } from '../tenenciaVivienda/tenenciaVivienda.service';
import { TipoAyudaService } from '../tipoAyuda/tipoAyuda.service';
import { TipoBecaService } from '../tipoBeca/tipoBeca.service';
import { TipoCuentaService } from '../tipoCuenta/tipoCuenta.service';
import { TipoDireccionService } from '../tipoDireccion/tipoDireccion.service';
import { TipoViviendaService } from '../tipoVivienda/tipoVivienda.service';
import { TvcableService } from '../tvcable/tvcable.service';
import { SolicitudBecaService } from '../solicitudBeca/solicitudBeca.service';
import { DuchaService } from '../ducha/ducha.service';
import { RepresentanteService } from '../representante/representante.service';
import { EncuestaPersonaService } from '../encuestaPersona/encuestaPersona.service';
import { SolicitudAyudaEconomicaService } from '../solicitudAyudaEconomica/solicitudAyudaEconomica.service';
import { PreguntaService } from '../pregunta/pregunta.service';
import { TipoPreguntaService } from '../tipoPregunta/tipoPregunta.service';
import { PonderacionIngresosService } from '../ponderacionIngresos/ponderacionIngresos.service';
import { CoeficienteViaticosService } from '../coeficienteViaticos/coeficienteViaticos.service';
import { InstitucionFinancieraPersonaAyudaService } from '../institucionFinancieraPersonaAyuda/institucionFinancieraPersonaAyuda.service';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedBienestarModule {
  static forRoot(): ModuleWithProviders<SharedBienestarModule> {
    return {
      ngModule: SharedBienestarModule,
      providers: [ControlInstitucionService, DireccionEstructuraFamiliarService, DireccionPersonaService,
        DiscapacidadService, ReferenciaFamiliarService, ConfiguracionSistemaService, TipoConfiguracionService,
        DiscapacidadPersonaService, EconomiaService, EconomiaPersonaService, EnfermedadService,
        EnfermedadPersonaService, EspecialidadService, EstructuraFamiliarService, EtapaService,
        EtniaService, FichaPersonaService, GeneroService, InstitucionService, PatrimonioFamiliarService,
        InstitucionPersonaService, InstruccionService, MaterialesViviendaService, NacionalidadService,
        OcupacionService, OrientacionSexualService, ParentezcoService, ProfesionService, NivelIdiomaService,
        PuebloService, ServiciosBasicosService, ServiciosBasicosPersonaService, SexoService,
        TenenciaViviendaService, TipoDireccionService, TipoEconomiaService, TipoInstitucionService,
        TipoViviendaService, UsoVehiculoService, OtraInstitucionPersonaService, UbicacionViviendaService,
        SeguroService, MaterialesPisoService, InodorosService, UsoViviendaService, IdiomaService,
        PatrimonioFamiliarPersonaService, SolicitudBecaService, TipoBecaService, DatosCalculoService
        , InstitucionFinancieraPersonaService, TipoCuentaService, InstitucionFinancieraService,
        IdiomaPersonaService, AguaService, DesechoAguasService, DuchaService, TelefonoConvencionalService,
        InternetService, TvcableService, DormitoriosService, GrupoSocioEconomicoService, TipoGpseService,
        MotivosBecaSolicitudService, MotivosBecaService, MaterialesParedService, RepresentanteService,
        CalculoGpseService, HistorialFichaPersonaService, HistorialSolicitudBecaService, EncuestaPersonaService,
        ValoracionService, TipoPreguntaService, PreguntaService,
        HistorialSolicitudAyudaService, RepresentanteAyudaService, SolicitudAyudaEconomicaService,
        TipoAyudaService, ContactoEmergenciaService, TituloEducacionService, TituloEducacionPersonaService,
        PonderacionIngresosService,CoeficienteViaticosService,InstitucionFinancieraPersonaAyudaService,

        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}
